import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PdfService } from '@services/pdf.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private http: HttpClient, private pdfService: PdfService) {}

  getFileSize(url: string): Observable<number | null> {
    // const _headers = new HttpHeaders({});
    return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
      map((response) => {
        const contentLength = response.headers.get('Content-Length');
        return contentLength ? parseInt(contentLength, 10) : null;
      })
    );
  }

  downloadPdfFile(doc: { name: string; url: string }) {
    const { name, url } = doc;
    return this.pdfService.downloadPdf({ name: name ?? 'noname', url });
  }

  convertBytesToMb = (bytes: number) => bytes / (1024 * 1024);
}
